import { set } from 'lodash';
import CheckoutActionType from '../../common/CheckoutActionType';
import FullAddressBuilder from '../../common/FullAddressBuilder';
import CreditAssessmentStatus from '../../model/CreditAssessmentStatus';

const initialState = {
  values: {
    speedChange: 'keepSpeed'
  }
};

const CheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CheckoutActionType.SET_CONNECTION_DATE_TO_PREFERRED:
      return {
        ...state,
        values: {
          ...state.values,
          connectionDate: 'preferred',
          preferredDate: undefined
        }
      };
    case CheckoutActionType.RESET_ALL:
      return initialState;
    case CheckoutActionType.SET_SPEED_CHANGE_OPTION:
      return { ...state, values: { speedChange: action.value } };
    case CheckoutActionType.CREDIT_ASSESSMENT_SET_CURRENT_ADDRESS: {
      const addressLines = FullAddressBuilder.getLines(action.currentAddress);
      const address = {};
      for (let i = 0; i < 4; i += 1) {
        if (addressLines[i]) {
          set(address, `addressLine${i + 1}`, addressLines[i]);
        } else {
          set(address, `addressLine${i + 1}`, undefined);
        }
      }
      return {
        ...state,
        values: {
          ...state.values,
          creditAssessment: {
            ...state.values.creditAssessment,
            currentAddress: {
              ...action.currentAddress,
              ...address
            }
          }
        }
      };
    }
    case CheckoutActionType.CREDIT_ASSESSMENT_SUBMITTING:
      return { ...state, caSubmitting: action.submitting };
    case CheckoutActionType.CREDIT_ASSESSMENT_STORE_APPLICATION_ID:
      return { ...state, values: { ...state.values, caApplicationId: action.value } };
    case CheckoutActionType.CREDIT_ASSESSMENT_STORE_RESULT:
      return { ...state, values: { ...state.values, caResult: action.value } };
    case CheckoutActionType.CREDIT_ASSESSMENT_SET_RESULT_VIEWED:
      return { ...state, values: { ...state.values, caResultViewed: action.value } };
    case CheckoutActionType.CREDIT_ASSESSMENT_SET_SUBMIT_COUNT:
      return { ...state, values: { ...state.values, caSubmitCount: action.value } };
    case CheckoutActionType.CREDIT_ASSESSMENT_ERROR:
      return { ...state, caError: action.error };
    case CheckoutActionType.FETCH_ADDRESSES:
      return { ...state, addresses: action.addresses };
    case CheckoutActionType.ADDRESS_SEARCH_ERROR:
      return { ...state, caAddressSearchError: action.value };
    case CheckoutActionType.CREDIT_ASSESSMENT_RESET_CURRENT_ADDRESS:
      return {
        ...state,
        values: {
          ...state.values,
          creditAssessment: {
            ...state.values.creditAssessment,
            currentAddress: undefined
          }
        }
      };
    default:
      return state;
  }
};

const getSpeedChangeOption = (state) => {
  if (
    state.form.checkout
    && state.form.checkout.values
  ) {
    return state.form.checkout.values.speedChange;
  }
  return 'keepSpeed';
};

const getConnectionDateError = (state) => {
  if (state.form.checkout && state.form.checkout.syncErrors) {
    return true;
  }
  return false;
};

const getCaSubmitCount = (state) => {
  if (state.form.checkout && state.form.checkout.values && state.form.checkout.values.caSubmitCount) {
    return state.form.checkout.values.caSubmitCount;
  }
  return 0;
};

const getCaSubmitting = (state) => {
  if (state.form.checkout && state.form.checkout.caSubmitting) {
    return state.form.checkout.caSubmitting;
  }
  return undefined;
};

const getCaError = (state) => {
  if (state.form.checkout && state.form.checkout.caError) {
    return state.form.checkout.caError;
  }
  return undefined;
};

const getAddresses = (state) => {
  if (state.form.checkout && state.form.checkout.addresses) {
    return state.form.checkout.addresses;
  }
  return [];
};

const isCaApproved = (state) => {
  if (state.form.checkout && state.form.checkout.values && state.form.checkout.values.caResult) {
    return state.form.checkout.values.caResult === CreditAssessmentStatus.APPROVED;
  }
  return false;
};

const hasInvalidInformation = (state) => {
  if (state.form.checkout && state.form.checkout.values && state.form.checkout.values.caResult) {
    return state.form.checkout.values.caResult === CreditAssessmentStatus.INCORRECT_ID;
  }
  return false;
};

const isCaResultViewed = (state) => {
  if (state.form.checkout && state.form.checkout.values && state.form.checkout.values.caResultViewed) {
    return state.form.checkout.values.caResultViewed;
  }
  return false;
};

const getCurrentAddress = (state) => {
  if (state.form.checkout.values
    && state.form.checkout.values.creditAssessment
    && state.form.checkout.values.creditAssessment.currentAddress) {
    return state.form.checkout.values.creditAssessment.currentAddress;
  }
  return {};
};

export const CheckoutSelector = {
  getConnectionDateError: state => getConnectionDateError(state),
  getSpeedChangeOption: state => getSpeedChangeOption(state),
  getCaSubmitCount: state => getCaSubmitCount(state),
  getCaSubmitting: state => getCaSubmitting(state),
  getCaError: state => getCaError(state),
  isCaApproved: state => isCaApproved(state),
  isCaResultViewed: state => isCaResultViewed(state),
  getAddresses: state => getAddresses(state),
  getCurrentAddress: state => getCurrentAddress(state),
  hasInvalidInformation: state => hasInvalidInformation(state)
};

export default CheckoutReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/CheckoutReducer.js
 **/